import React from "react";
import ModalWrapper from "../../../app/common/modals/ModalWrapper";
import { Container } from "semantic-ui-react";
import { useSelector } from "react-redux";

export default function ServiceSubmittingModal({ service = "job post" }) {
  const { responsive } = useSelector((state) => state.app);

  return (
    <ModalWrapper
      size="tiny"
      style={{ width: !responsive.isMobile ? 450 : "98%" }}
      modalClassName="modal-ux-wrapper"
      showAnimation={"fade"}
      hideAnimation={"fade"}
      showDuration={200}
      hideDuration={200}
      closeOnEscape={false}
      closeOnDimmerClick={false}
      isClose={false}
    >
      <div className="post-action-modal">
        <Container textAlign="center">
          <div>
            <div className="modal-blue-text" style={{ fontSize: 20 }}>
              Submitting your {service}…
            </div>
            <div className="modal-blue-text">
              This will only take a few seconds. Please don’t refresh this page
              or close your browser.
            </div>
          </div>
        </Container>
      </div>
    </ModalWrapper>
  );
}
